import { defineComponent as o, openBlock as r, createBlock as v, unref as l, mergeProps as h, withCtx as p, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconWatchBand",
  __name: "IconWatchBand",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (c, e) => (r(), v(l(m), h(n, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        a("path", { d: "M12.004 7.25a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75m0-2.75a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M13.5 2a2.25 2.25 0 0 1 2.25 2.25v5.897a2 2 0 0 1 0 3.705v.884A2.25 2.25 0 0 1 17 16.75v3A2.25 2.25 0 0 1 14.75 22h-5.5A2.25 2.25 0 0 1 7 19.75v-3a2.25 2.25 0 0 1 1.25-2.014v-.884a2 2 0 0 1 0-3.706V4.25A2.25 2.25 0 0 1 10.5 2h3m2 14.777a2.25 2.25 0 0 1-2 1.223h-.75v.75a.75.75 0 0 1-1.5 0V18H10.5a2.25 2.25 0 0 1-2-1.223v2.973a.75.75 0 0 0 .75.75h5.5a.75.75 0 0 0 .75-.75v-2.973M9.75 15.75a.75.75 0 0 0 .75.75h.75v-.75a.75.75 0 0 1 1.5 0v.75h.75a.75.75 0 0 0 .75-.75V14h-4.5v1.75M9 11.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H9m1.5-8a.75.75 0 0 0-.75.75V10h4.5V4.25A.75.75 0 0 0 13.5 3.5h-3",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
